module.exports = __webpack_public_path__ + "img/demo2.46aa6ec9.png";